<template>
  <v-col>
    <Breadcrumbs :title="'Suppliers'"></Breadcrumbs>
    <PageTitle :title="'Supplier Info'" class="pt-3 mx-3"></PageTitle>
    <v-overlay :value="loading" :opacity="1" :color="'#FFFFFF'">
      <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <div class="col-md-12 col-lg-12 pt-12">
        <SupplierView></SupplierView>
      </div>
    </v-row>
  </v-col>
</template>

<script>
import SupplierView from "../../components/suppliers/SupplierView.vue";
import Breadcrumbs from "@/components/shared/Breadcrumbs";
import PageTitle from "@/components/shared/PageTitle";  
import { createNamespacedHelpers } from "vuex";

const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "Supplier",
  components: {
    SupplierView,
    Breadcrumbs,
    PageTitle,
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      profile: "profile",
    }),
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
  },
};
</script>